<template>
  <div class="page-title">
    <h1 class="page-title__text">{{ displayTitle }}</h1>
    <p v-if="subtitle" class="page-title__sub">{{ subtitle }}</p>
  </div>
</template>
<script>
export default {
  name: 'header-title',
  props: ['title', 'title_img_src', 'subtitle'],
  computed: {
    displayTitle () {
      if (this.title) return this.title
      // legacy callers pass an svg filename like `ticket-raffles-title.svg`
      return String(this.title_img_src || 'Swiftorland')
        .replace(/\.svg$/i, '')
        .replace(/-title$/i, '')
        .replace(/-/g, ' ')
        .toUpperCase()
    }
  }
}
</script>
<style scoped>
.page-title {
  text-align: center;
  padding: 18px 0 26px;
}

.page-title__text {
  margin: 0;
  font-family: var(--sl-font-display);
  font-weight: 400;
  font-size: 68px;
  line-height: 1;
  letter-spacing: 3px;
  background: linear-gradient(180deg, #ffffff 0%, #cfd2da 45%, #7c8090 56%, #eef0f4 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 3px 0 rgba(0, 0, 0, 0.55));
}

.page-title__sub {
  color: #8f8f99;
  font-size: 15px;
  max-width: 560px;
  margin: 8px auto 0;
  line-height: 1.45;
}

@media (max-width: 720px) {
  .page-title__text {
    font-size: 44px;
    letter-spacing: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header-Title.vue